{
  "buttons": {
    "manage": "Manage"
  }
}
